import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {UnstyledButton} from '../../../atoms/Buttons/UnstyledButton';
import {Icon} from '../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../atoms/Icon/IconName';

interface Props {
  label: string;
  onReset: () => void;
  className?: string;
  dataTestId?: string;
}

export const ResetFiltersButton = ({
  onReset,
  label,
  className,
  dataTestId,
  ref,
}: Props & {ref?: React.Ref<HTMLButtonElement>}) => {
  return (
    <ResetButton
      onClick={onReset}
      data-testid={dataTestId}
      className={className}
      ref={ref}
      aria-label={undefined}
    >
      <Icon size={'S'} asset={GenericIconName.Reset} />
      {label}
    </ResetButton>
  );
};

const ResetButton = styled(UnstyledButton)`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.Black};
  padding: 16px;
  background: transparent;
  outline: 0;
  border: 0;
  margin-left: -1rem;
  cursor: pointer;
`;
